// extracted by mini-css-extract-plugin
var _1 = "pageLoader__RYJoj";
export { _1 as "pageLoader" }
export default { "pageLoader": _1 }
